var TeamMembersPopup = {

    modalId: '#modal__teamMember',
    modalDetailsId: "#details__teamMember",
    modalArea: null,
    modal: null,
    modalTriggerClass: '.teamPopup',

    me: this,

    InitTeamMembersPopup: function () {

        this.modalArea = document.querySelector(this.modalDetailsId);
        this.modal = document.querySelector(this.modalId);

        var modalTrigger = document.querySelectorAll(this.modalTriggerClass)
        modalTrigger.forEach(function (el) {
            el.addEventListener('click', function (e) {
                e.preventDefault();
                this.modalArea.innerHTML = "";
                var memberId = event.currentTarget.getAttribute('data-memberId');
                this.modal.classList.add('modal--active');
                this.DoTeamMembersPopup(memberId);

            }.bind(this));
        }.bind(this));
    },

    DoTeamMembersPopup: function (teamMemberId) {
        let prom = this.GetMemberMarkup(teamMemberId);
        prom.then(
            function (result) {
                console.log(result.markup);
                this.modalArea.innerHTML = result.markup;
            }.bind(this)   // Bind the parent scope to this
        );
    },

    GetMemberMarkup: function (teamMemberId) {
        let mParams = { memberId: teamMemberId  };

        return new Promise(function (resolve, reject) {

            fetch('/Umbraco/Surface/TeamMemberPopup/GetTeamMemberMarkup', {
                body: JSON.stringify(mParams), method: 'post', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            })
                .then(function (response) {
                    //console.log('response : %o', response.json());
                    resolve(response.json());
                })
                .catch(error => {
                    console.log('Failed', error);
                    reject(error);
                });
        });
    }
}